import React from 'react'

export default ({fill="currentColor"}) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 87 87'><path d='M22.142 21.775L64.57 64.202m.29-42.427L22.433 64.202' fill='none' fillRule='evenodd' stroke={fill} strokeWidth='3' strokeLinecap='square' /></svg>
)



// WEBPACK FOOTER //
// ./src/components/Icons/Close.jsx